const API_KEY = process.env.REACT_APP_API_KEY

const API_URL = 'https://fakestoreapi.com/products'

export {
  API_KEY,
  API_URL 
}